import { IPrizeClassDescriptor } from '@/components/game/implementations/_default/_domain/models/prize-element';
import { GamePrizeDescriptorsUk, GamePrizeDescriptorsSpain, GamePrizeDescriptorsItaly, GamePrizeDescriptorsSweden, GamePrizeDescriptorsNetherlands } from '@/components/game/_domain/server/_factory/game-class-bindings-country-specific/index';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

class GamePrizeDescriptors {
  public static getGamePrizeClasses(): { [key: string]: IPrizeClassDescriptor; } {
    const persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
    const userPreferences = persistedStore.Get(UserPreferences);

    const userCountry: string = userPreferences.country.toLowerCase();

    switch (userCountry) {
      case 'it':
        const itGameBindings = new GamePrizeDescriptorsItaly();
        return itGameBindings.getGamePrizeClasses();
      case 'es':
        const esGameBindings = new GamePrizeDescriptorsSpain();
        return esGameBindings.getGamePrizeClasses();
      case 'se':
        const seGameBindings = new GamePrizeDescriptorsSweden();
        return seGameBindings.getGamePrizeClasses();
      case 'nl':
        const nlGameBindings = new GamePrizeDescriptorsNetherlands();
        return nlGameBindings.getGamePrizeClasses();
      default:
      const ukGameBindings = new GamePrizeDescriptorsUk();
      return ukGameBindings.getGamePrizeClasses();
    }
  }
}

export { GamePrizeDescriptors };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/_factory/game-class-bindings.ts